import { useEffect, useRef } from 'react';

const INACTIVITY_MS = 2 * 60 * 60 * 1000; // 2 valandos
const THROTTLE_MS = 60 * 1000; // resetinti taimerį ne dažniau kaip kartą per minutę

function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('sessionId');
  window.location.href = '/login?reason=inactivity';
}

/**
 * Jei vartotojas prisijungęs (yra token), po 2 val neaktyvumo automatiškai atsijungia.
 * Aktyvumas: pelės judesys, paspaudimai, klaviatūra, scroll, touch.
 */
function useInactivityLogout() {
  const timeoutRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const scheduleLogout = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        logout();
      }, INACTIVITY_MS);
    };

    const onActivity = () => {
      const now = Date.now();
      if (now - lastActivityRef.current < THROTTLE_MS) return;
      lastActivityRef.current = now;
      scheduleLogout();
    };

    scheduleLogout();

    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach((ev) => window.addEventListener(ev, onActivity));

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      events.forEach((ev) => window.removeEventListener(ev, onActivity));
    };
  }, []);
}

export default useInactivityLogout;
